'use client'

import { useState } from 'react'
import Link from 'next/link'
import Form from '../ui/Form/Form'
import FormItem from '../ui/Form/FormItem'
import { Button, Checkbox, Notification } from '../ui'
import NotificationContainer from './NotificationContainer'

export default function SubscribeForm() {
    const [email, setEmail] = useState('')
    const [agree, setAgree] = useState(false)
    const [error, setError] = useState('')
    const [success, setSuccess] = useState(false)

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()

        setSuccess(false)

        if (!email) {
            setError('Введите ваш email')
            return
        }

        if (!email.includes('@')) {
            setError('Введите корректный email')
            return
        }

        if (!agree) {
            setError('Необходимо согласие на обработку данных')
            return
        }

        setError('')
        setEmail('')
        setAgree(false)
        setSuccess(true)
    }

    return (
        <Form onSubmit={handleSubmit}>
            <FormItem
                invalid={!!error && !agree}
                errorMessage={'Введите корректный email'}
            >
                <input
                    type="email"
                    placeholder="Введите ваш email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-3 py-2 border rounded bg-white text-black focus:outline-none focus:ring-1 focus:ring-second"
                />
            </FormItem>

            <FormItem
                invalid={!!error && !agree}
                errorMessage={'Согласие обязательно'}
            >
                <label className="flex gap-3 mt-3 items-start text-sm">
                    <Checkbox
                        checked={agree}
                        onChange={(checked) => setAgree(checked)}
                        checkboxClass="text-second"
                    />
                    <span>
                        Я выражаю согласие на обработку персональных данных в
                        соответствии с{' '}
                        <Link href="/policy" className="underline">
                            Политикой конфиденциальности
                        </Link>
                    </span>
                </label>
            </FormItem>

            <Button
                type="submit"
                className="mt-4 w-full bg-white text-black transform hover:scale-105 transition-all duration-300"
            >
                Отправить
            </Button>

            {success && (
                <NotificationContainer position="bottom-right">
                    <Notification className="mt-4" closable type="success">
                        <div className="font-bold text-second">
                            Спасибо! <br /> Подписка оформлена
                        </div>
                    </Notification>
                </NotificationContainer>
            )}
        </Form>
    )
}
